// hooks/useSessionTimer.ts
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

const useSessionTimer = () => {
  const [remainingTime, setRemainingTime] = useState<number | null>(null);

  useEffect(() => {
    const checkSession = () => {
      const expiresAt = Cookies.get('admin-token-expires');
      if (!expiresAt) {
        setRemainingTime(null);
        return;
      }

      const expirationTime = new Date(expiresAt).getTime();
      const now = Date.now();
      const timeLeft = Math.max(0, Math.floor((expirationTime - now) / 1000)); // in seconds

      setRemainingTime(timeLeft);
    };

    // Check immediately
    checkSession();

    // Set up interval to check every second
    const timer = setInterval(checkSession, 1000);

    return () => clearInterval(timer);
  }, []);

  return remainingTime;
};

export default useSessionTimer;